module.exports = __webpack_public_path__ + "img/pexels-tetyana-kovyrina-9832187.3cc9ad45.jpg";